var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00033,
    cy: 9.00033,
    r: 8.33333,
    fill: "#40629F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9741 5.51474C13.2882 5.17828 13.8155 5.1601 14.1519 5.47412C14.4884 5.78815 14.5066 6.31548 14.1926 6.65193L8.35923 12.9019C8.05455 13.2284 7.54672 13.2566 7.20769 12.9661L4.29102 10.4661C3.94158 10.1665 3.90112 9.64045 4.20063 9.29101C4.50015 8.94157 5.02624 8.9011 5.37567 9.20062L7.68584 11.1808L12.9741 5.51474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipIcon);
export default __webpack_public_path__ + "static/media/vip-icon.a3cd616fe8451c2a36993b186c2d0a3d.svg";
export { ForwardRef as ReactComponent };